// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3524":"app","8144":"onboard","9002":"patient"}[chunkId] + ".css";
};